enum Condition {
  IS_NULL = 'IS NULL',
  EQ = '=',
  NE = '!=',
  LTE = '<=',
  LT = '<',
  GTE = '>=',
  GT = '>',
  IS_NOT_NULL = 'IS NOT NULL',
  INCLUDES = 'INCLUDES',
  EXCLUDES = 'EXCLUDES',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  IS_TRUE = 'IS TRUE',
  IS_FALSE = 'IS FALSE'
}

/**
 * Conditions that are complete on their own and take no right-hand operand
 * (neither a value nor a column). The Filter UI hides the RHS inputs for these,
 * and validation must not require a right operand.
 */
export function isUnaryCondition(condition: Condition): boolean {
  return (
    condition === Condition.IS_NULL ||
    condition === Condition.IS_NOT_NULL ||
    condition === Condition.IS_TRUE ||
    condition === Condition.IS_FALSE
  )
}

export default Condition
